"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RyftPaymentStatus = exports.RyftAccountStatus = void 0;
var RyftAccountStatus;
(function (RyftAccountStatus) {
    RyftAccountStatus["NOT_CREATED"] = "NotCreated";
    RyftAccountStatus["NOT_REQUIRED"] = "NotRequired";
    RyftAccountStatus["REQUIRED"] = "Required";
    RyftAccountStatus["PENDING"] = "Pending";
    RyftAccountStatus["APPROVED"] = "Approved";
    RyftAccountStatus["DECLINED"] = "Declined";
})(RyftAccountStatus = exports.RyftAccountStatus || (exports.RyftAccountStatus = {}));
var RyftPaymentStatus;
(function (RyftPaymentStatus) {
    RyftPaymentStatus["DISABLED"] = "disabled";
    RyftPaymentStatus["REQUESTED"] = "requested";
    RyftPaymentStatus["ENABLED"] = "enabled";
})(RyftPaymentStatus = exports.RyftPaymentStatus || (exports.RyftPaymentStatus = {}));
